import { IFontSize, IInputType, InputType } from 'app/util/theme';
import { mergeStyles } from 'react-select';
import { DefaultTheme } from 'styled-components';

import { FONT_SIZES } from '../../pages/frames/components/styled-components/GlobalStyle/constants';

export const HEIGHT_SIZES: IFontSize = {
  baseline: 40,
  compact: 12,
};

const INPUT_TYPES: Partial<IInputType> = {
  basic: 4,
  rounded: 20,
};

export const IS_MULTI: boolean = false;

export const STYLES: Record<InputType, (theme: DefaultTheme) => any> = {
  basic: (theme: DefaultTheme) => defaultStyle(theme),
  line: (theme: DefaultTheme) => mergeStyles(defaultStyle(theme), lineStyle(theme)),
  rounded: (theme: DefaultTheme) => defaultStyle(theme),
};

const COLORS = {
  background: {
    default: '#ffffff',
    disabled: 'rgba(0, 0, 0, 0.05)',
    focused: 'rgba(0, 0, 0, 0.05)',
    selected: 'rgba(0, 0, 0, 0.05)',
  },
  border: {
    default: '#bab7b9',
    focused: '#47a8ae',
  },
  font: {
    default: 'rgba(0, 0, 0, 0.7)',
    disabled: 'rgba(0, 0, 0, 0.7)',
    focused: 'rgba(0, 0, 0, 0.7)',
    selected: 'rgba(0, 0, 0, 0.4)',
  },
};

export const defaultStyle = (theme: DefaultTheme) => ({
  control: (base: any, { isDisabled }: any) => ({
    ...base,
    backgroundColor: isDisabled ? COLORS.background.disabled : COLORS.background.default,
    borderColor: isDisabled ? 'transparent' : '#4966e0',
    borderRadius: `${INPUT_TYPES[theme.inputType] ?? INPUT_TYPES.basic}px`,
    borderStyle: 'solid',
    borderWidth: '1px',
    height: `${HEIGHT_SIZES[theme.fontSize] ?? HEIGHT_SIZES.baseline}px`,
  }),
  indicatorsContainer: (base: any, state: any) => ({
    ...base,
    fontSize: '7px',
    div: {
      color: '#636363',
      padding: '12px',
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
      transition: 'all .1s ease',
    },
    transform: state.isSelected ? 'rotate(180deg)' : 'none',
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    display: 'none',
  }),
  menu: (base: any) => ({
    ...base,
    backgroundColor: '#ffffff',
    borderRadius: `${INPUT_TYPES[theme.inputType] ?? INPUT_TYPES.basic}px`,
    boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.16)',
    margin: '0',
  }),
  menuList: (base: any) => ({
    ...base,
    borderRadius: `${INPUT_TYPES[theme.inputType] ?? INPUT_TYPES.basic}px`,
    padding: 0,
  }),
  option: (base: any, { isFocused, isSelected }: any) => ({
    ...base,
    backgroundColor: isSelected
      ? COLORS.background.selected
      : isFocused
      ? COLORS.background.focused
      : COLORS.background.default,
    color: COLORS.font.default,
    fontFamily: 'Inter',
    fontSize: `${FONT_SIZES[theme.fontSize] ?? FONT_SIZES.baseline}px`,
    fontWeight: '300',
    '&:hover': {
      backgroundColor: COLORS.background.focused,
      color: COLORS.font.default,
    },
    padding: '16px 15px',
  }),
  singleValue: (base: any) => ({
    ...base,
    color: COLORS.font.selected,
    fontFamily: 'Inter',
    fontSize: `${FONT_SIZES[theme.fontSize] ?? FONT_SIZES.baseline}px`,
    fontWeight: '300',
    height: '20px',
    lineHeight: 1,
    margin: 0,
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: '0 15px',
  }),
  placeholder: (base: any) => ({
    ...base,
    margin: '0',
  }),
});

export const lineStyle = (theme: DefaultTheme) => ({
  control: (base: any) => ({
    ...base,
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '0 0 0 0',
    boxShadow: '0',
    fontSize: `${FONT_SIZES[theme.fontSize] ?? FONT_SIZES.baseline}px`,
    height: '30px',
    minHeight: '30px',
  }),
  menu: (base: any) => ({
    ...base,
    top: '40px',
  }),
  singleValue: (base: any, { isDisabled }: any) => ({
    ...base,
    color: isDisabled ? 'rgba(0, 0, 0, 0.38)' : COLORS.font.default,
    fontWeight: 'normal',
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: '0',
  }),
});
